export class S3RestoreTarget {
    'bucketName';
    'encryptionKeyId';
    'prefix';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3RestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
